import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../../../../components/NavBarAdmin";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loading-icons";
import { Grid } from "../../../../Layout/Grid/GridView";
import Request from "../../../../../api/Requests";

const EventsTransactionsDetails = () => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const gridRef = useRef();
    const [state, setState] = useState({
        tickets: [],
        event: {
            id: 0,
            name: "",
            id_venues: "",
        },
        modalFormTableReservation: {
            show: false,
            data: {
                table: {},
            },
        },
        modalFormTableReservationInfo: {
            show: false,
            data: {
                table: {},
            },
        },
    });

    useEffect(() => {
        document.title = "Event Tickets | Nightspot Dashboard";
        getEventTicketsTransactionList();
    }, []);

    const getEventTicketsTransactionList = async (closeFormTableReservation = false) => {
        setIsLoading(true);
        let info = await Request('admin/event-details-tickets-transactions', 'GET', { id_events: params.id_events, id_transaction: params.id_transaction }, true)
        if (info && info.status) {
            setState(info.data);
        }
        setIsLoading(false);
    };

    const verifyPaymentTransaction = async () => {
        setIsLoading(true);
        let info = await Request('admin/event-verify-payment-transaction', 'GET', { id_events: params.id_events, id_transaction: params.id_transaction }, true)
        if (info && info.status) {
            toast.success("Transação verificada com sucesso.");
            getEventTicketsTransactionList();
        } else {
            toast.error("Erro ao verificar transação.");
        }
        setIsLoading(false);
    };


    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#333" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };




    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        {isLoading ? (
                            <InsideLoading />
                        ) : (
                            <>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-md-6 col-lg-6">
                                                <h2>Detalhes da transação</h2>
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-end">
                                                <Link to={`/my/admin/venues/${state.event.id_venues}/events/${state.event.id}/transactions`} className="btn btn-primary">
                                                    Voltar
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="card mt-3">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-12 col-md-4">
                                                        <h5>Nome do cliente</h5>
                                                        <p>{state.transaction.client_name}</p>
                                                        <h5>Email</h5>
                                                        <p>{state.transaction.owner_email}</p>
                                                        <h5>Telefone</h5>
                                                        <p>{state.transaction.client_phone_country} {state.transaction.client_phone_number}</p>
                                                        <h5>NIF</h5>
                                                        <p>{state.transaction.owner_vat_number}</p>
                                                    </div>
                                                    <div className="col-12 col-md-4">
                                                        <h5>Data da transação</h5>
                                                        <p>{state.transaction.transaction_date}</p>
                                                        <h5>Data do pagamento</h5>
                                                        <p>{state.transaction.payment_datetime}</p>
                                                        <h5>Método de pagamento</h5>
                                                        <p>{state.transaction.payment_method}</p>
                                                        <h5>Nº transação</h5>
                                                        <p>{state.transaction.transaction_number}</p>
                                                        <h5>Estado Pagamento</h5>
                                                        <p>{state.transaction.payment_status}</p>
                                                    </div>
                                                    <div className="col-12 col-md-4">
                                                        <h5>Valor Total Bilhetes</h5>
                                                        <p>{state.transaction.transaction_price_ticket}</p>
                                                        <h5>% Taxa</h5>
                                                        <p>{state.transaction.transaction_price_fee}</p>
                                                        <h5>Taxa Fixa (€)</h5>
                                                        <p>{state.transaction.transaction_price_fee_fixed}</p>
                                                        <h5>Valor Total Transação</h5>
                                                        <p>{state.transaction.transaction_price_total}</p>
                                                        {state.transaction.payment_transaction_id && (
                                                            <>
                                                                <h5>ID Transação</h5>
                                                                <p>{state.transaction.payment_transaction_id}</p>
                                                            </>
                                                        )}
                                                        {state.transaction.payment_error_mensage && (
                                                            <>
                                                                <h5>Mensagem de erro</h5>
                                                                <p>{state.transaction.payment_error_mensage}</p>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col">
                                                            <button className="btn btn-primary me-2" onClick={() => verifyPaymentTransaction()}>Verificar estado pagamento</button>

                                                            <button className="btn btn-warning me-2">Forçar marcar como pago.</button>

                                                            <button className="btn btn-danger me-2">Devolver pagamento</button>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </NavBar >
        </div >
    );

}

export default EventsTransactionsDetails;
